import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

import user from "./user";
import product from "./product";
import sale from "./sale";
import reports from "./reports";
import checkoutBuilder from "./checkoutBuilder";
import plan from "./plan";
import offer from "./offer";
import integration from "./integration";
import notifications from "./notifications";
import optionForm from "./optionForm";
import optionSupport from "./optionSupport";
import productPage from "./productPage";
import financial from "./financial";
import subscriptions from "./subscriptions";
import funnel from "./funnel";
import partnersCenter from "./partnersCenter";
import membersModules from "./membersModules";
import membersLessons from "./membersLessons";
import membersSetup from "./membersSetup";
import membersStudents from "./membersStudents";
import membersComments from "./membersComments";
import membersGroups from "./membersGroups";
import membersCategories from "./membersCategories";
import membersQuizzes from "./membersQuizzes";
import membersReleases from "./membersReleases";

import invoiceNfe from "./invoiceNfe";
import events from "./events";
import cardMachine from "./cardMachine";

Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  state,
  mutations,
  modules: {
    user,
    product,
    sale,
    membersQuizzes,
    reports,
    checkoutBuilder,
    plan,
    offer,
    integration,
    notifications,
    optionForm,
    optionSupport,
    productPage,
    financial,
    subscriptions,
    funnel,
    partnersCenter,
    membersModules,
    membersLessons,
    membersSetup,
    membersStudents,
    membersComments,
    membersGroups,
    membersCategories,
    membersReleases,

    invoiceNfe,
    events,
    cardMachine
  }
});
